module.exports = __webpack_public_path__ + "img/regularWork.31d93a1a.png";